import React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { keyframes } from '@mui/system'

const wave = keyframes`
  from {
    transform: scaleY(0.55);
    opacity: 0.5;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
`

const BARS = [
  { height: 7, delay: 0 },
  { height: 12, delay: 150 },
  { height: 9, delay: 300 },
]

interface ICallStatusWaveProps {
  /** Height of the tallest bar, the other bars are scaled to it */
  size?: number
}

/** Animated bars for in-progress call states (connecting, ringing). Takes the current text color */
const CallStatusWave = ({ size = 12 }: ICallStatusWaveProps) => {
  const scale = size / 12

  return (
    <Stack
      aria-hidden="true"
      direction="row"
      alignItems="center"
      gap={`${2 * scale}px`}
      height={14 * scale}
      flexShrink={0}
    >
      {BARS.map(({ height, delay }) => (
        <Box
          key={delay}
          component="i"
          sx={{
            width: 2 * scale,
            height: height * scale,
            borderRadius: '2px',
            bgcolor: 'currentColor',
            animation: `${wave} 800ms ease-in-out ${delay}ms infinite alternate`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }}
        />
      ))}
    </Stack>
  )
}

export default CallStatusWave
